// extracted by mini-css-extract-plugin
module.exports = {"bannerImgContainer":"post-module--bannerImgContainer--3SopW","bannerImg":"post-module--bannerImg--2yAgf","blogArticle":"post-module--blogArticle--1Ro02"};